// @ts-nocheck
import { IconOffset } from "@toolkit/Framework/Types/Icon";
import * as React from "react";

const Plus: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path fill="currentColor" d="M11.5 12.5H6v-1h5.5V6h1v5.5H18v1h-5.5V18h-1v-5.5Z" />
        </svg>
        /* Store Custom Code - End */
    );
};

export const PlusOffset: IconOffset = {
    vertical: 24, // Store Custom Code
    horizontal: 24, // Store Custom Code
};

export default React.memo(Plus);
